import React from 'react';

const Credits: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-[#f47521] mb-8">Credits</h1>

      {/* Special Thanks Section */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#f47521] mb-4">Special Thanks</h2>
        <div className="space-y-4">
          <div className="bg-[#1e2736] p-6 rounded-lg">
            <h3 className="text-xl font-bold text-[#f47521] mb-3">amustycow</h3>
            <p className="text-gray-300 mb-4">
              Professional Rocket League freestyler and content creator. 
              Check out his amazing content:
            </p>
            <div className="space-y-2">
              <a 
                href="https://www.youtube.com/@amustycow" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-[#f47521] hover:text-[#ff8534] transition-colors"
              >
                YouTube: @amustycow
              </a>
              <a 
                href="https://twitter.com/amustycow" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-[#f47521] hover:text-[#ff8534] transition-colors"
              >
                Twitter: @amustycow
              </a>
            </div>
          </div>

          <div className="bg-[#1e2736] p-6 rounded-lg">
            <h3 className="text-xl font-bold text-[#f47521] mb-3">uuest</h3>
            <p className="text-gray-300 mb-4">
              Professional Rocket League freestyler known for incredible shot accuracy.
              Follow him on:
            </p>
            <div className="space-y-2">
              <a 
                href="https://www.youtube.com/@uuest/featured" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-[#f47521] hover:text-[#ff8534] transition-colors"
              >
                YouTube: @uuest
              </a>
              <a 
                href="https://twitter.com/uuestRL" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-[#f47521] hover:text-[#ff8534] transition-colors"
              >
                Twitter: @uuestRL
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Creator Section */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#f47521] mb-4">Created By</h2>
        <div className="bg-[#1e2736] p-6 rounded-lg">
          <h3 className="text-xl font-bold text-[#f47521] mb-3">hishima</h3>
          <p className="text-gray-300 mb-4">
            Rocket League freestyler and content creator. Join the community and follow the journey!
          </p>
          <div className="space-y-3">
            {/* Twitch - Primary Platform */}
            <a 
              href="https://www.twitch.tv/hishima9" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block bg-[#6441a5] text-white py-3 px-6 rounded-lg text-center hover:bg-[#7d5bbe] transition-colors transform hover:scale-105 font-bold text-lg shadow-lg"
            >
              🎮 Watch Live on Twitch
            </a>
            
            {/* Other Social Links */}
            <div className="grid grid-cols-2 gap-3 mt-4">
              <a 
                href="https://discord.gg/zpNNEdYTn8" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block bg-[#5865F2] text-white py-2 px-4 rounded text-center hover:bg-[#4752c4] transition-colors"
              >
                Join Discord
              </a>
              <a 
                href="https://x.com/Hishima09" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block bg-[#1DA1F2] text-white py-2 px-4 rounded text-center hover:bg-[#1a8cd8] transition-colors"
              >
                Follow on Twitter
              </a>
              <a 
                href="https://www.youtube.com/@hishima9" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block bg-[#FF0000] text-white py-2 px-4 rounded text-center hover:bg-[#d90000] transition-colors"
              >
                Subscribe on YouTube
              </a>
              <a 
                href="https://www.instagram.com/hishima09" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block bg-[#E4405F] text-white py-2 px-4 rounded text-center hover:bg-[#d6314d] transition-colors"
              >
                Follow on Instagram
              </a>
              <a 
                href="https://www.tiktok.com/@hishima09" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block bg-black text-white py-2 px-4 rounded text-center hover:bg-gray-800 transition-colors"
              >
                Follow on TikTok
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Version Information */}
      <section>
        <h2 className="text-2xl font-semibold text-[#f47521] mb-4">Version Information</h2>
        <div className="text-gray-300">
          <p>Current Version: 1.0.0</p>
          <p>Last Updated: {new Date().toLocaleDateString()}</p>
        </div>
      </section>
    </div>
  );
};

export default Credits; 